import { clearDashboardCache } from './dashboardCache';
import { ADMIN_URL, APP_URL } from './adminSite';

// A super admin opens a club from the portal: the portal gets an hour-long
// token for that club and hands it to /open-club in a new tab. Whoever was
// signed in on that site is put aside and restored on the way out.
const RETURN_KEY = 'rtc-open-club-return';
const RETURN_USER_KEY = 'rtc-open-club-return-user';
const USER_KEY = 'tl-user';

const read = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const write = (k, v) => { try { v == null ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch { /* storage blocked */ } };

const isLocal = (hostname) => /^(localhost|127\.0\.0\.1)$/.test(hostname);

// Live: the club opens on app.runthe.club. A local copy keeps it on this site.
export const openClubUrl = (token, hostname = window.location.hostname) =>
  `${isLocal(hostname) ? '' : APP_URL}/open-club#${token}`;
// The portal on this site when the super admin was signed in here (they can
// use it on any site), otherwise the admin site
const portalUrl = (restoredUser, hostname = window.location.hostname) => {
  let role = null;
  try { role = JSON.parse(restoredUser || 'null')?.role; } catch { /* not JSON */ }
  return `${isLocal(hostname) || role === 'SUPER_ADMIN' ? '' : ADMIN_URL}/super-admin`;
};

const claims = (token) => {
  try { return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))); } catch { return null; }
};
const isOpenClubToken = (token) => Boolean(token && claims(token)?.actingClubId);

// Called by /open-club with the token from the address
export function startOpenClub(token) {
  const current = read('token');
  // Opening a second club from inside one keeps the original sign-in to go back to
  if (!isOpenClubToken(current)) {
    write(RETURN_KEY, current);
    write(RETURN_USER_KEY, read(USER_KEY));
  }
  write('token', token);
  write(USER_KEY, null);
  clearDashboardCache();
  window.location.replace('/dashboard');
}

// Back to the portal, restoring whoever was signed in here before.
// Returns false when this isn't an opened club.
export function leaveOpenClub() {
  if (!isOpenClubToken(read('token'))) return false;
  const restoredUser = read(RETURN_USER_KEY);
  write('token', read(RETURN_KEY));
  write(USER_KEY, restoredUser);
  write(RETURN_KEY, null);
  write(RETURN_USER_KEY, null);
  clearDashboardCache();
  window.location.assign(portalUrl(restoredUser));
  return true;
}
